import { ExpenseTypeEligibility } from 'core/domain/expenses/expenseTypeEligibility'

export const elegibilityItemMap = new Map<number, string>([
  [ExpenseTypeEligibility.Reimbursable, 'far fa-check-circle'],
  [ExpenseTypeEligibility.ReimbursableWithEob, 'far fa-clipboard-list'],
  [ExpenseTypeEligibility.ReimbursableWithDoctorsNote, 'far fa-user-md'],
  [ExpenseTypeEligibility.ReimbursableWithPrescription, 'far fa-pills'],
  [ExpenseTypeEligibility.NotReimbursable, 'far fa-ban'],
  [ExpenseTypeEligibility.HSANotEligible, 'far fa-pig'],
])
